import { payloadAction } from "utils/stateUtils";

//auth
export const USER_LOGIN_REQUEST = 'USER_LOGIN_REQUEST';
export const FORGOT_PASSWORD = "FORGOT_PASSWORD";
//auth
export const loginWithEmailPass = (auth) => payloadAction(USER_LOGIN_REQUEST)({ auth });
export const forgotPassword = (user) => payloadAction(FORGOT_PASSWORD)({ user });